import styled from "styled-components";
import theme from "themes/simple-theme";

interface IProps {
  transparent?: boolean;
}

const Divider = styled.div`
  width: 100%;
  height: 3rem;
  display: block;
  ${({ transparent }: IProps) =>
    transparent
      ? `
    `
      : `border-bottom: 1px solid ${theme.color.primary};`};
`;

Divider.defaultProps = {
  transparent: false
};

export default Divider;



// WEBPACK FOOTER //
// ./src/components/common/Divider.tsx